<template>
  <section class="container flex flex-col lg:flex-row justify-center items-center relative z-10">
    <nuxt-link :to="{name: 'contact'}" :aria-label="title" class="z-10">
      <h4 class="bubble bg-contain lg:bg-cover bg-no-repeat px-12 lg:px-16 pt-16 pb-24 font-strong text-white text-2xl text-center" v-text="title"/>
    </nuxt-link>
    <div class="card z-0 bg-white h-48 lg:h-32 w-10/12 lg:w-6/12 xl:w-5/12 xxl:w-4/12 -mt-24 lg:-ml-16 lg:pl-8 lg:mt-0">
      <div v-if="contact" class="grid relative sm:grid-cols-4 lg:grid-cols-3 lg:-mt-2-35 xl:-mt-3-15 h-full">
        <img :data-src="contact.image" alt="Onze adviseur" class="hidden lg:block lazyload">
        <div class="h-full flex flex-col justify-center items-center lg:items-start text-center lg:text-left col-start-2 col-end-4 sm:mt-2 md:mt-8">
          <p class="font-semi w-8/12 sm:w-full lg:w-10/12 pt-8 pb-2 lg:pt-0" v-text="content"/>
          <a :href="`mailto:${contact.email}`" class="font-strong" v-text="link"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState({
      contact: state => state.contact,
    }),
    link() {
      return `Neem contact op met ${this.contact.name}`;
    },
  },
  created() {
    this.$store.dispatch('setContact');
  },
};
</script>

<style lang="sass" scoped>
.bubble
  background-image: url("~assets/img/bg-cta.svg")

.grid
  &:before
    position: absolute
    content: ''
    top: -70%
    right: 8%
    height: 120px
    width: 100px
    z-index: -1
    background: url("~assets/img/bg-cta2.svg") no-repeat
    background-size: contain

  @media(min-width: theme('screens.sm'))
    &:before
      right: 30%

  @media(min-width: theme('screens.lg'))
    &:before
      top: -20px
      left: -40px
      right: 0
</style>
